export default function FeatureShowcase() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400">SS</span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 tracking-tight">
            Why Superbuy Spreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-900 rounded-3xl p-8 flex flex-col justify-between min-h-[340px]">
            <div>
              <div className="w-10 h-10 rounded-full bg-background-50/15 flex items-center justify-center mb-6">
                <span className="text-background-50 text-sm font-bold">A</span>
              </div>
              <h3 className="font-heading text-2xl text-background-50 font-semibold leading-tight">
                All-in-One<br />Sourcing
              </h3>
            </div>
            <p className="text-sm text-background-50/50 leading-relaxed mt-4">
              One spreadsheet to rule them all. Browse Shoes, Hoodies, Jackets, Accessories and more from a single organized hub.
            </p>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[340px]">
            <img
              src="https://readdy.ai/api/search-image?query=Fashion%20inspiration%20moodboard%20concept%20with%20Polaroid%20style%20photos%20of%20sneakers%20caps%20and%20accessories%20pinned%20on%20a%20warm%20cork%20board%20surface%2C%20soft%20natural%20daylight%2C%20cream%20walls%20in%20background%2C%20creative%20editorial%20style%2C%20eclectic%20but%20curated%20composition%2C%20warm%20beige%20and%20terracotta%20tones%2C%20artistic%20lifestyle%20photography%2C%20cozy%20creative%20studio%20atmosphere&width=800&height=600&seq=feature-card-01-v2&orientation=landscape"
              alt="Curated fashion products for US buyers on Superbuy Spreadsheet"
              title="Superbuy Spreadsheet curated collection"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
            <div className="absolute top-4 left-4">
              <span className="px-3 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full text-xs text-background-50 font-medium">
                Buying Guide
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="font-heading text-2xl text-background-50 font-semibold leading-tight">
                Curated for US Buyers
              </h3>
            </div>
          </div>

          <div className="bg-background-100 rounded-3xl p-8 flex flex-col justify-between min-h-[340px]">
            <div>
              <h3 className="font-heading text-2xl text-foreground-950 font-semibold leading-tight">
                Trusted by<br />Thousands
              </h3>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
                10K+ active sheets powering smart buying decisions every day.
              </p>
            </div>
            <div className="mt-auto pt-8">
              <div className="rounded-2xl overflow-hidden aspect-[16/9]">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20a%20laptop%20showing%20a%20colorful%20organized%20dashboard%20interface%2C%20a%20ceramic%20coffee%20cup%20and%20a%20small%20succulent%20plant%20beside%20it%2C%20warm%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20cream%20white%20walls%2C%20calm%20productive%20workspace%20atmosphere%2C%20editorial%20home%20office%20photography%2C%20soft%20focus%20background%2C%20minimal%20and%20tidy%20composition&width=600&height=340&seq=feature-card-02-v2&orientation=landscape"
                  alt="Superbuy Spreadsheet shopping dashboard on laptop"
                  title="Superbuy Spreadsheet dashboard"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}